import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["href", "onMouseover"]
const _hoisted_2 = ["data-qa"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_comment_user_balloon = _resolveComponent("comment-user-balloon")

  return (_openBlock(), _createBlock(_component_comment_user_balloon, { author: $props.author }, {
    trigger: _withCtx(({ showBalloon }) => [
      _createElementVNode("a", {
        href: $props.author.profileUrl,
        class: "gfu-link--nofx",
        onMouseover: $event => ($options.onMouseover(showBalloon))
      }, [
        _createElementVNode("h5", {
          class: _normalizeClass($options.triggerClasses),
          "data-qa": `project-comment-author-nickname:${$props.author.userID}`
        }, _toDisplayString($props.author.nickname), 11 /* TEXT, CLASS, PROPS */, _hoisted_2)
      ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_1)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["author"]))
}